import type { Course, CourseTee } from '@/lib/db/types';
import { courseHandicap } from '@/lib/games/handicap';

/** Expected gross score from handicap + course/tee (prototype expectedScoreLine). */
export function expectedScoreForCourse(
  handicap: number | null | undefined,
  course: Pick<Course, 'par'>,
  tee: Pick<CourseTee, 'course_rating' | 'slope'> | null | undefined,
): number {
  const par = course.par ?? 72;
  const slope = tee?.slope ?? 130;
  const cr = tee?.course_rating ?? par;
  const ch = courseHandicap(handicap ?? 18, slope, cr, par, 18);
  return Math.round(par + ch);
}

export function clampCallTarget(target: number, expected: number): number {
  return Math.min(Math.max(60, target), expected);
}
